export default __webpack_public_path__ + "static/media/obituary.d9e1ae15.jpg";